<template>
  <Help :help-page="helpPage" :theme="theme" />
</template>

<script>
import { mapState } from 'vuex';
import Help from '@nsftx/games-sdk-js/src/components/Help';
import gamesStatic from '@nsftx/games-sdk-js/src/api/gamesStatic';

export default {
  name: 'GameHelp',
  components: {
    Help,
  },
  data() {
    return {
      helpPage: '',
    };
  },
  computed: {
    ...mapState(['config']),
    theme() {
      return this.config?.ui?.config?.theme;
    },
  },
  async mounted() {
    const { productName, locale, tenantId } = this.config;
    this.helpPage = await gamesStatic.getHelp(productName, locale, tenantId);
  },
};
</script>
